module.exports = __webpack_public_path__ + "media/audio5.6bef0170.mp3";